import { Space, Table, Input, Popconfirm } from 'antd';
import { SearchOutlined, EditFilled } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import './Users.css';
// import { useGetCharacters } from "../../../../hooks/useGetAdmin";
import { useNavigate } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';

const GET_CHARACTERS = gql`
  query GetCharacters {
    players {
      id
      steamName
      license
      fullName
      cash
      bank
      crypto
    }
  }
`;

function App() {
  // const { data, isError, isFetching } = useGetCharacters();
  const { data, error, loading: isFetching } = useQuery(GET_CHARACTERS);
  const [characters, setCharacters] = useState([]);
  const [searchText, setSearchText] = useState('');

  const navigate = useNavigate();

  const handleEdit = (key) => {
    console.log(key);
  }

  const columns = [
    {
      title: 'CID',
      dataIndex: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'steamName',
    },
    {
      title: 'License',
      dataIndex: 'license',
    },
    {
      title: 'Character Name',
      dataIndex: 'fullName',
    },
    {
      title: 'Cash',
      dataIndex: 'cash',
      sorter: (a, b) => a.cash - b.cash,
      render: (cash) => `$${cash.toLocaleString()}`,
    },
    {
      title: 'Bank',
      dataIndex: 'bank',
      sorter: (a, b) => a.bank - b.bank,
      render: (cash) => `$${cash.toLocaleString()}`,
    },
    {
      title: 'Crypto',
      dataIndex: 'crypto',
      sorter: (a, b) => a.crypto - b.crypto,
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      align: 'center',
      width: '5%',
      render: (_, record) =>
        characters.length >= 1 ? (
          <Space>
            <Popconfirm title="Edit coming soon" onConfirm={() => handleEdit(record.key)}>
              <EditFilled />
            </Popconfirm>
          </Space>
        ) : null,
    }
  ];

  useEffect(() => {
    if (!isFetching && data && data.players) {
      setCharacters(data.players);
    }
  }, [data, isFetching]);

  useEffect(() => {
    if (searchText && (data && data.players)) {
      const filteredCharacters = data.players.filter((character) => {
        return character.name.toLowerCase().includes(searchText.toLowerCase());
      });

      setCharacters(filteredCharacters);
    } else {
      setCharacters(data?.players);
    }
  }, [searchText, data]);

  const onTableChange = (pagination, filters, sorter, extra) => {
    console.log(pagination, filters, sorter, extra)
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div>
        <h1>Characters</h1>
        <p>List of all characters registered. <i>(Click on a character to view their profile)</i></p>
      </div>
      <Input
        type="text"
        value={searchText}
        prefix={<SearchOutlined />}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search"
        style={{ width: '300px' }}
      />
      <Table
        columns={columns}
        dataSource={characters}
        loading={isFetching}
        rowKey="id"
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              navigate(`/admin/characters/${record.id}`);
              // console.log(record, rowIndex);
            },
          };
        }}
        onChange={onTableChange}
      />
    </Space>
  );
}

export default App;
